import { Dispatch, SetStateAction } from 'react';

import { AddOrEditWebhookForm } from '@/components/modules/Webhooks/components/AddOrEditWebhookForm';
import { useWebhooks } from '@/components/modules/Webhooks/hooks/useWebhooks';
import {
  AddOrEditWebhookFormSchema,
  AddOrEditWebhookFormType,
} from '@/components/modules/Webhooks/schemas/AddOrEditWebhookForm.schema';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { getBlankDefaultValuesFromZodSchema } from '@/utils/getBlankDefaultValuesFromZodSchema';

export type AddWebhookDialogProps = {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
  userId: string;
};

export const AddWebhookDialog = ({ opened, setOpened, toggleDialog, userId }: AddWebhookDialogProps) => {
  const { getTextIdTranslation: t } = useTranslation();
  const { createWebhook, loading } = useWebhooks(userId);

  const onSubmit = async (formValues: AddOrEditWebhookFormType) => {
    await createWebhook(formValues);
    toggleDialog();
  };

  const blankDefaultValues = getBlankDefaultValuesFromZodSchema(AddOrEditWebhookFormSchema(t));

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'ADD_WEBHOOK'}
      onSubmitForm={onSubmit}
      isLoading={loading}
      defaultValues={blankDefaultValues}
      formSchema={AddOrEditWebhookFormSchema}
    >
      <>
        <AddOrEditWebhookForm fieldVariant={FieldVariant.form} fullWidth />
      </>
    </EditDialogWrapper>
  );
};
